import React, { useState } from 'react';
import './KeuGoiHanhDongCuoi.css';

const KeuGoiHanhDongCuoi = () => {
  const [phone, setPhone] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Phone submitted:', phone);
    alert('Đăng ký thành công! Chúng tôi sẽ liên hệ với bạn sớm nhất.');
  };

  return (
    <section className="final-cta">
      <div className="container">
        <div className="cta-content">
          <h2 className="cta-title">Bạn Đã Sẵn Sàng Trúng 10 Triệu Chưa?</h2>
          <p className="cta-subtitle">
            Đăng ký ngay để nhận 1 lượt quay số may mắn MIỄN PHÍ
            <br />
            Hàng trăm người đã trúng thưởng hôm nay - Bạn có muốn là người tiếp theo không?
          </p>
          
          <form className="cta-form" onSubmit={handleSubmit}>
            <div className="cta-form-group">
              <label htmlFor="phone-cta" className="sr-only">Số điện thoại</label>
              <input
                id="phone-cta"
                type="tel"
                placeholder="Nhập số điện thoại của bạn"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
                className="cta-input"
                aria-label="Nhập số điện thoại để đăng ký chơi game may mắn"
                pattern="[0-9]{10,11}"
                title="Vui lòng nhập số điện thoại hợp lệ (10-11 chữ số)"
              />
              <button type="submit" className="cta-button-large" aria-label="Bắt đầu chơi game may mắn miễn phí ngay bây giờ">
                <span className="button-text-full">BẮT ĐẦU NGAY - HOÀN TOÀN MIỄN PHÍ</span>
                <span className="button-text-mobile">BẮT ĐẦU NGAY</span>
                <span className="button-arrow" aria-hidden="true">→</span>
              </button>
            </div>
            <div className="cta-trust">
              <div className="trust-item">
                <span className="trust-icon">✓</span>
                <span>Không cần thẻ tín dụng</span>
              </div>
              <div className="trust-item">
                <span className="trust-icon">🔒</span>
                <span>Bảo mật 100%</span>
              </div>
              <div className="trust-item">
                <span className="trust-icon">⚡</span>
                <span>Đăng ký trong 30 giây</span>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="cta-background-decoration"></div>
    </section>
  );
};

export default KeuGoiHanhDongCuoi;

